import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CheckCircle, XCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPendenciaConcluida = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('pendência concluída') || 
           acaoLower.includes('pendencia concluida') ||
           acaoLower.includes('pendência recusada') ||
           acaoLower.includes('pendencia recusada') ||
           acaoLower.includes('pendência respondida') ||
           acaoLower.includes('pendencia respondida') ||
           acaoLower.includes('respondeu pendência') ||
           acaoLower.includes('respondeu pendencia') ||
           acaoLower.includes('concluída como') ||
           acaoLower.includes('concluida como');
};

const getIconPendenciaConcluida = (acao: string): { Icon: LucideIcon; color: string } => {
    const acaoLower = acao.toLowerCase().trim();
    
    if (acaoLower.includes('recusada') || acaoLower.includes('recusou')) {
        return { Icon: XCircle, color: 'var(--ce5293f)' };
    }
    
    return { Icon: CheckCircle, color: 'var(--c2e86de)' };
};

export default function CardPendenciaConcluida({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconPendenciaConcluida(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const pendenciaConcluidaConfig = {
    tipo: 'pendencia_concluida',
    detectaTipo: detectaPendenciaConcluida,
    getIcon: getIconPendenciaConcluida,
    temExpansao: () => true,
    Component: CardPendenciaConcluida
};

